/**
 * Browser preference: whether admin "pencil" controls show on destination & travel style cards.
 * Stored per device; default false (hidden) until the admin enables it.
 */
export const CARD_IMAGE_EDIT_OVERLAY_STORAGE_KEY = 'globethrivers_show_card_image_edit_overlay';

export function readCardImageEditOverlayPreference(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const v = localStorage.getItem(CARD_IMAGE_EDIT_OVERLAY_STORAGE_KEY);
  if (v === null) {
    return false;
  }
  return v === 'true' || v === '1';
}

export function writeCardImageEditOverlayPreference(show: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(CARD_IMAGE_EDIT_OVERLAY_STORAGE_KEY, show ? 'true' : 'false');
}
